<!-- 待财务付款跟进 -->
<template>
  <div>
    <div class="opage">
      <!-- 资金/待财务付款跟进 -->
      <baseBreadcrumb :menu="$t('message.money')" :page="$t('message.purchasePayCheckPurchaseList')"></baseBreadcrumb>
      <div class="tab">
        <tableTab :val.sync="form.remind_flag" :list="[
          // 全部
          { name: '全部', value: '0' },
          // 财务提醒补充 
          { name: '财务提醒补充 ', value: '1' },
        ]
          " :fun="getData">
        </tableTab>

      </div>

      <div class="searchBox">
        <!-- 客户ID -->
        <el-input size="small" :placeholder="$t('message.clientID')" v-model="form.user_id" clearable></el-input>
        <!-- 客户姓名 -->
        <!-- <el-input size="small" :placeholder="$t('message.clientName')" v-model="form.realname" clearable></el-input> -->
        <!-- 交易号 -->
        <el-input size="small" :placeholder="$t('message.transactionNumber')" v-model="form.purchase_no"
          clearable></el-input>
        <!-- 订单号 -->
        <el-input size="small" :placeholder="$t('message.orderNumber')" v-model="form.order_sn" clearable></el-input>
        <!-- 来源平台 -->
        <el-select size="small" :placeholder="$t('message.fromPlatform')" v-model="form.from_platform" clearable>
          <el-option label="1688" value="1688">
          </el-option>
          <el-option label="taobao" value="taobao">
          </el-option>
          <el-option label="163" value="163">
          </el-option>
        </el-select>
        <!-- 平台支付状态 -->
        <!-- <el-select size="small" v-model="form.platform_is_paid" :placeholder="$t('message.platformPaymentStatus')"
          clearable>
          <el-option label="未查到" value="0">
          </el-option>
          <el-option label="已支付" value="1">
          </el-option>
          <el-option label="未支付" value="2">
          </el-option>
        </el-select> -->

        <!-- 是否可支付 -->
        <el-select size="small" v-model="form.buyerRemarkIcon" :placeholder="$t('message.isPayable')" clearable>
          <el-option label="可支付" value="3">
          </el-option>
          <el-option label="不可支付" value="1">
          </el-option>
        </el-select>

        <div class="btns">
          <!-- 筛选 -->
          <el-button size="small" type="primary" @click="getData">{{
            $t("message.filter")
          }}</el-button>
          <!-- 重置 -->
          <!-- <el-button size="small" @click="chongZhi">{{
            $t("message.reset")
                        }}</el-button> -->
        </div>
      </div>
      <div style="padding: 0 20px">
        <el-table :data="tableData" :header-cell-style="{ 'text-align': 'center', background: '#EDEFF4' }" :cell-style="{
          'text-align': 'center',

        }" size="mini" @selection-change="handleSelectionChange" :max-height="tableautoheight"
          :row-class-name="tableRowClassName">
          <el-table-column property="rowNumber" width="50" label="No"></el-table-column>
          <el-table-column type="selection" width="45" align="center">
          </el-table-column>

          <!-- 来源平台 -->
          <el-table-column property="from_platform" :label="$t('message.fromPlatform')">
            <template slot-scope="scope">
              {{ scope.row.from_platform }}
              <p v-if="scope.row.duoduo_order"> <el-tag
                  :type="scope.row.duoduo_order.buyerRemarkIcon == 3 ? 'success' : 'info'" size="mini"
                  :class="{ 'bgcRed': scope.row.duoduo_order.buyerRemarkIcon == 2, 'bgcYellow': scope.row.duoduo_order.buyerRemarkIcon == 4, 'bgcBlue': scope.row.duoduo_order.buyerRemarkIcon == 1 }">
                  {{ scope.row.duoduo_order.buyerRemarkIcon == 3 ? '可支付' :
                    '不可支付' }}</el-tag>
              </p>
            </template>
          </el-table-column>
          <!-- 交易号 -->
          <el-table-column property="purchase_no" :label="$t('message.transactionNumber')"
            width="120"></el-table-column>
          <!-- 订单号 -->
          <el-table-column property="order_sn" :label="$t('message.orderNumber')" width="130">
            <template slot-scope="scope">
              <router-link :to="`/orderPaymentDetail?order_sn=${scope.row.order_sn}`" target="_blank" class="a-link">
                {{ scope.row.order_sn }}
              </router-link>
              <p>{{ scope.row.client_realname }}</p>
            </template>
          </el-table-column>
          <!-- 番号 -->
          <el-table-column :label="$t('message.mash')">
            <template slot-scope="scope">
              {{ scope.row.sorting }}
            </template>
          </el-table-column>
          <!-- 购买账户 -->
          <el-table-column :label="$t('message.buyAccount')">
            <template slot-scope="scope">
              {{ scope.row.g_realname }}
            </template>
          </el-table-column>
          <!-- 交易号内商品数量 -->
          <el-table-column property="totalNum" :label="$t('message.totalQuantity')">
          </el-table-column>
          <!-- 客户总付款 -->
          <el-table-column property="client_amount" :label="$t('message.totalPaymentAmount')">
          </el-table-column>
          <!-- 采购填写成本 -->
          <el-table-column property="system_amount" :label="$t('message.purchaseCost')">
          </el-table-column>
          <!-- 1688应付款 -->
          <el-table-column property="platform_amount" label="1688/淘宝应付款">
          </el-table-column>
          <!-- 平台支付状态 -->
          <el-table-column property="platform_is_paid_name"
            :label="$t('message.platformPaymentStatus')"></el-table-column>
          <!-- 金额匹配状态 -->
          <el-table-column property="amount_matched_name" :label="$t('message.amountMatchStatus')">
            <template slot-scope="scope">
              <el-button :type="scope.row.amount_matched == 0 ? 'danger' : 'success'" size="small"> {{
                scope.row.amount_matched_name }}</el-button>
            </template>
          </el-table-column>

          <!-- 不匹配原因说明 -->
          <el-table-column property="mismatch_reason" :label="$t('message.unmatchedReason')"></el-table-column>

          <!-- 补充资料 -->
          <el-table-column :label="$t('message.supplementalMaterials')">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" class="primary" v-if="scope.row.supplement_at">查看</el-button>
            </template>
          </el-table-column>
          <!-- 操作 -->
          <el-table-column property="operation" :label="$t('message.operation')">
            <template slot-scope="scope">
              <!-- 补充资料 -->
              <el-button type="primary" size="mini" @click="supplementalMaterials(scope.row)" class="primary">{{
                $t('message.supplementalMaterials') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="allpag">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="form.page"
          :page-sizes="[30, 50, 100, 200, 300]" :page-size="form.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>

    </div>
    <!-- 补充资料弹窗 -->
    <el-dialog title="补充资料" :visible.sync="isShowDetail" width="680px" :close-on-click-modal="false" center>
      <div class="dialog-content">
        <div class="row">
          <div class="lable">补充资料内容:</div>
          <div class="value"><el-input v-model="supplementData.supplement_text" type="textarea" rows="4"></el-input>
          </div>

        </div>
        <div class="row">
          <div class="lable">补充资料图片:</div>
          <div class="value">
            <div class="img-box" v-for="(item, index) in supplementData.supplement_images" :key="index">
              <el-image :src="item" fit="fill" :preview-src-list="[item]" style="width: 100px; height: 100px; " />
              <i class="el-icon-error" @click="supplementData.supplement_images.splice(index, 1)"></i>
            </div>
            <el-upload class="avatar-uploader" :action="'#'" :show-file-list="false" :http-request="httpupimgList">
              <div class="plus">
                <i class="el-icon-plus"></i>
              </div>
            </el-upload>
          </div>
        </div>
        <div class="row">
          <div class="lable">补充资料文件:</div>
          <div class="value">
            <div>
              <div class="file" v-for="(item, index) in supplementData.supplement_files" :key="index">
                <el-link :href="item.url" target="_blank" type="primary">{{ item.name }}</el-link>
                <i class="el-icon-error" @click="supplementData.supplement_files.splice(index, 1)"
                  style="color: #fa5058; font-size: 16px; vertical-align: middle; margin-left: 5px;"></i>
              </div>
              <el-upload :action="'#'" :show-file-list="false" :http-request="httpupfileList">
                <el-button type="primary" size="mini">点击上传</el-button>
              </el-upload>
            </div>
          </div>
        </div>
      </div>
      <template slot="footer" class="dialog-footer">
        <!-- 取消 -->
        <el-button @click="isShowDetail = false">{{ $t('message.cancel') }}</el-button>
        <!-- 确认 -->
        <el-button type="primary" @click="purchasePayCheckSupplement">{{ $t('message.confirm') }}</el-button>
      </template>
    </el-dialog>
    <!-- 补充资料弹窗 -->
    <supplementalMaterials ref="supplementalMaterials"></supplementalMaterials>
  </div>
</template>
<script>
import myImage from "@/components/uploadFile/uploadFile.vue";
import tableTab from "../components/tableTab.vue";

import supplementalMaterials from "../components/supplementalMaterials.vue";
export default {
  data() {
    return {
      tableautoheight: window.innerHeight > 700 ? window.innerHeight - 240 : 800,
      isShowDetail: false,
      supplementData: {

      }, // 补充资料数据
      form: {
        page: 1,
        pageSize: 30,
      },
      value: [],
      total: 0,
      loading: null,
      tableData: [],
      selectedRows: [],
      dialogVisible: false, // 淘宝支付弹框是否显示
      taobaoData: {
        "will_pay_purchase_order_ids": [
        ],

        "pay_failed_results": [
        ],
        "pay_failure_purchase_order_ids": [
        ]
      }
    };
  },
  components: {
    myImage,
    tableTab,

    supplementalMaterials,
  },
  computed: {

    g() {
      return this.$store.state.authWorkGroupAdmin.g;
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    tableRowClassName({ row, }) {
      if (row.remind_flag) {
        return 'remind-row';
      }
    },
    // 获取数据
    getData() {
      this.$api.financialApi
        .purchasePayCheckPurchaseList(this.form)
        .then((res) => {
          // console.log("事件名", res.data.data);
          if (res.code != 0) return this.$message.error(res.msg);
          // 接下来的操作
          this.tableData = res.data.data;
          this.total = res.data.total
          this.$forceUpdate();
        });
    },


    handleSizeChange(val) {
      this.form.pageSize = val;
      this.form.page = 1;
      this.getData();
    },
    handleCurrentChange(val) {
      this.form.page = val;
      this.getData();
    },
    // 处理选择变化
    handleSelectionChange(val) {
      this.selectedRows = val;
    },

    // 查看补充资料
    supplementalMaterials(row) {
      let item = JSON.parse(JSON.stringify(row))
      this.supplementData = {
        id: item.id,
        supplement_text: item.supplement_text,
        supplement_images: item.supplement_images,
        supplement_files: item.supplement_files,
      }
      this.$forceUpdate()
      this.isShowDetail = true
    },
    // 上传补充资料图片
    async httpupimgList(file) {
      if (this.supplementData.supplement_images.length >= 6) return this.$message.error('最多上传6张图片')
      let data = await this.createClient(file)

      this.supplementData.supplement_images.push(data.data)
      this.$forceUpdate()
    },
    // 上传补充资料文件
    async httpupfileList(file) {
      let data = await this.createClient(file)

      this.supplementData.supplement_files.push({
        name: file.file.name,
        url: data.data,
      })
      this.$forceUpdate()
    },
    // 提交补充资料
    purchasePayCheckSupplement() {
      if (!this.supplementData.supplement_text && !this.supplementData.supplement_images.length && !this.supplementData.supplement_files.length) return this.$message.error('请输入补充资料')
      this.$api.financialApi.purchasePayCheckSupplement(this.supplementData).then(res => {
        this.$message.success(res.msg);
        this.isShowDetail = false
        this.getData()
      })
    },
  },
};
</script>
<style lang='scss' scoped='scoped'>
// @import "@/css/mixin.scss";

.routerView {
  height: 100%;
}

.opage {
  background-color: #f8f8f8;
  height: 100%;


}

.tab {
  position: relative;

  .operation {
    position: absolute;
    top: 0;
    right: 0;
  }
}

.searchBox {
  display: flex;
  align-items: center;
  padding-left: 24px;
  margin-bottom: 15px;

  >* {
    flex: 0 0 140px;
    margin-right: 15px;
  }



  .btns {
    flex: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    padding: 0;

    .el-button {
      width: 64px;
      margin-left: 15px;
    }
  }
}

/deep/.tableMy {
  th {
    font-size: 14px;
    color: #333;
    font-weight: 400;
  }

  p {
    font-size: 14px;
    color: #333333;
    line-height: 20px;
  }

  .keHu {
    p {
      text-align: center;
    }
  }

  .dingDanZhiFuRuJin {
    p {
      text-align: left;
    }
  }

  .lianXiFangShi {
    color: #2c96e7;
    cursor: pointer;
  }

  .link {
    color: #fa5058;
  }

  .btnGroup {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .el-button {
      display: flex;
      margin: 0 0 8px 0;
    }
  }
}



.allpag {
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 25px 0;
  padding-bottom: 10px;
}

/deep/.el-textarea__inner {
  padding: 5px !important;
  height: 100px !important;
  resize: none;
}

.bgcRed {
  background-color: #fa5058 !important;
  color: #fff !important;
}

.bgcYellow {
  background-color: #f5a623 !important;
  color: #fff !important;
}

.bgcBlue {
  background-color: #2c96e7 !important;
  color: #fff !important;
}

.taobaoData {
  padding: 20px;

  p {
    margin-bottom: 10px;
  }

  .will_pay {
    font-weight: bold;
    font-size: 16px;
  }

  .pay_failed {

    font-size: 16px;
    color: #fa5058;
  }
}

/deep/.cell {
  padding: 0 3px !important;
}



/deep/.remind-row {
  background-color: rgba(242, 210, 235, 0.5) !important;
}

/deep/.el-table tbody .remind-row:hover>td {
  background-color: rgba(242, 210, 235, 0.5) !important;
}

.dialog-content {
  padding: 20px;

  .row {
    margin-bottom: 20px;
    display: flex;

    .lable {
      width: 140px;
      margin-right: 15px;
    }

    .value {
      flex: 1;
      display: flex;

      .avatar-uploader {
        width: 100px;
        height: 100px;
        border-radius: 5px;
        border: 1px dashed #dcdfe6;

        .plus {
          width: 100px;
          height: 100px;
          display: flex;
          justify-content: center;
          align-items: center;
        }

      }

      .img-box {
        margin-right: 10px;
        position: relative;

        .el-icon-error {
          position: absolute;
          top: -5px;
          right: -5px;
          font-size: 18px;
          color: #fa5058;
          cursor: pointer;
        }
      }

      .file {
        margin-bottom: 10px;

      }
    }
  }
}
</style>
